import { render, staticRenderFns } from "./ProgramSearchComponent.vue?vue&type=template&id=77b00ca6&scoped=true&"
import script from "./ProgramSearchComponent.vue?vue&type=script&lang=ts&"
export * from "./ProgramSearchComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramSearchComponent.vue?vue&type=style&index=0&id=77b00ca6&lang=scss&scoped=true&"
import style1 from "./ProgramSearchComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b00ca6",
  null
  
)

export default component.exports